// src/components/Layout.js
import React from 'react';
import { MdOutlineWorkHistory } from "react-icons/md";
import { MdOutlineRequestQuote } from "react-icons/md";
import { NavLink } from 'react-router-dom';
import { FaScaleBalanced } from "react-icons/fa6";
import { IoIosTimer } from "react-icons/io";
import './layout.css';

const ProvidentLayout = ({ children }) => {
  return (
    <div >
      <h1 className="provident-fund-title">
        <FaScaleBalanced className="provident-fund-icon" />
        Provident Fund
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="provident-fund-link"
                className="nav-link"
                to="/provident-fund"
                activeClassName="active"
              >
                <MdOutlineWorkHistory className="nav-icon" /> Provident Fund
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="provident-fund-history-link"
                className="nav-link"
                to="/provident-fund-history"
                activeClassName="active"
              >
                <IoIosTimer  className="nav-icon" /> Provident Fund History
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="provident-fund-req-link"
                className="nav-link"
                to="/provident-fund-req"
                activeClassName="active"
              >
                <MdOutlineRequestQuote className="nav-icon" /> Provident Fund Requests
              </NavLink>
            </li>
           
            
           
          </ul>
        </div>
        <div className="content">
          {children} {/* Render the child components here */}
        </div>
      </section>
    </div>
  );
};

export default ProvidentLayout;
